import React, { useState } from "react"

import ReactMarkdown from "react-markdown"
// import { FaFacebookF, FaInstagram, FaTwitter } from "react-icons/fa"
import { graphql, useStaticQuery } from "gatsby"
import Image from "gatsby-image"

export const query = graphql`
    {
        allAirtable(filter: {table: {eq: "Team"}}) {
            nodes {
                id
                data {
                    name
                    description
                    facebook_link
                    image {
                        localFiles {
                            childImageSharp {
                                fluid {
                                    ...GatsbyImageSharpFluid
                                }
                            }
                        }
                    }
                    instagram_link
                    position
                    twitter_link
                }
            }
        }
    }
`
// onClick={() => setIsModal(true)}

const Team = () => {
  const { allAirtable: { nodes: teamMembers } } = useStaticQuery(query)

  const [isModal, setIsModal] = useState(false)
  const [desc, setDesc] = useState("")
  const [memberName, setMemberName] = useState("")

  const openModal = (teamMemberName, teamMemberDesc) => {
    setIsModal(true)
    setMemberName(teamMemberName)
    setDesc(teamMemberDesc)
  }

  const closeModal = () => {
    setIsModal(false)
    setMemberName("")
    setDesc("")
  }

  const modalClass = () => (isModal ? { display: "block" } : "")

  return (
    <section className="page-section bg-light" id="team">
      <div className="container my-5">
        <div className="text-center">
          <h2 className="section-heading text-uppercase">Meet Our Amazing Team</h2>
          <h3 className="section-subheading text-muted mb-5">Click on the image to get to know us a little more.</h3>
        </div>
        <div className="row">
          {teamMembers.map((member, index) => {
            const {
              data: {
                id,
                name,
                description,
                position,
                // facebook_link,
                // instagram_link,
                // twitter_link,
                image
              }
            } = member
            const memberImg = image.localFiles[0].childImageSharp.fluid

            return (
              <div className="col-lg-4" key={index}>
                <div className="team-member">
                  <div role="button" tabIndex={0} onKeyDown={() => setIsModal(true)}
                       onClick={() => openModal(name, description)}
                       style={{ cursor: "pointer" }}>
                    <Image fluid={memberImg} className="mx-auto rounded-circle custom-circle pointer profile"
                           alt={name} />
                  </div>
                  <h4>{name}</h4>
                  <p className="text-muted">{position}</p>
                  {/*<a aria-label='twitter' className="btn btn-dark btn-social mx-2"*/}
                  {/*   href={twitter_link}><FaTwitter /></a>*/}
                  {/*<a aria-label='facebook' className="btn btn-dark btn-social mx-2"*/}
                  {/*   href={facebook_link}><FaFacebookF /></a>*/}
                  {/*<a aria-label='instagram' className="btn btn-dark btn-social mx-2"*/}
                  {/*   href={instagram_link}><FaInstagram /></a>*/}
                </div>

                {
                  isModal ? (
                    <div className="modal" style={modalClass()} id="channelModal" key={id}>
                      <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable" role="document">
                        <div className="modal-content">
                          <div className="modal-header">
                            <h5 className="modal-title text-dark text-center">Bio for {memberName}</h5>

                            <button
                              onClick={closeModal}
                              style={{ color: "#000" }}
                              type="button"
                              className="close"
                              data-dismiss="modal"
                              aria-label="Close"
                            >
                              <span aria-hidden="true">&times;</span>
                            </button>
                          </div>

                          <div className="modal-body">
                            <ReactMarkdown source={desc} />
                          </div>
                          <div className="modal-footer">
                            <button onClick={closeModal} type="button" className="btn btn-lg">
                              Close
                            </button>
                          </div>

                        </div>
                      </div>
                    </div>
                  ) : null
                }
              </div>
            )
          })}
        </div>
      </div>
    </section>
  )
}

export default Team
